import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  getItem<T>(key: string) : T | null {
    const value = localStorage.getItem(key);
    return !value ? null : value as T;
  }

  setItem(key: string, value: any) {
    if (!value) return;
    localStorage.setItem(key, value);
  }

  removeItem(key: string) {
    localStorage.removeItem(key);
  }
}
